import React from 'react';
import Logo from './landing/Logo';

/**
 * Legacy alias — now renders the unified EvalentX brand <Logo />.
 * Kept for backwards compatibility with existing callers (Navbar, Footer, etc.).
 *
 * @param {string} size - 'sm' | 'md' | 'lg' | 'xl'
 * @param {boolean} showIcon - kept for API compatibility (the X mark always renders now)
 * @param {boolean} showTagline - kept for API compatibility (no-op)
 * @param {string} subtitle - optional contextual subtitle (e.g. "Arena", "for Companies")
 * @param {string} className - additional CSS classes
 */
const CodeversityLogo = ({
  size = 'md',
  // eslint-disable-next-line no-unused-vars
  showIcon = true,
  // eslint-disable-next-line no-unused-vars
  showTagline = false,
  // eslint-disable-next-line no-unused-vars
  tagline,
  subtitle,
  className = ''
}) => {
  // Map legacy 'xl' to new 'lg' (the largest supported size in the unified Logo)
  const mapped = size === 'xl' ? 'lg' : size;

  return (
    <span className={className}>
      <Logo size={mapped} subtitle={subtitle} noLink />
    </span>
  );
};

export default CodeversityLogo;
